/** "há 3 dias", "há 5 minutos"... a partir de uma data ISO. */
function formatarTempoRelativo(iso: string): string {
  const minutos = Math.round((Date.now() - new Date(iso).getTime()) / 60_000);
  const formatador = new Intl.RelativeTimeFormat("pt-BR", { numeric: "auto" });

  if (minutos < 60) return formatador.format(-minutos, "minute");
  const horas = Math.round(minutos / 60);
  if (horas < 24) return formatador.format(-horas, "hour");
  const dias = Math.round(horas / 24);
  if (dias < 30) return formatador.format(-dias, "day");
  const meses = Math.round(dias / 30);
  if (meses < 12) return formatador.format(-meses, "month");
  return formatador.format(-Math.round(meses / 12), "year");
}

function formatarDataHora(iso: string): string {
  return new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}

/**
 * EXPORTS
 */
export { formatarDataHora, formatarTempoRelativo };
